export default __webpack_public_path__ + "static/media/miguel-lopes-15.354664d1.jpg";